import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Enviaremos un link a su correo para restaurar su contraseña.", -1)
const _hoisted_3 = { class: "input" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LInput = _resolveComponent("LInput")!
  const _component_l_buttom = _resolveComponent("l-buttom")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("form", null, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_LInput, {
          disabledB: true,
          pholder: "En desarrollo"
        })
      ]),
      _createVNode(_component_l_buttom, {
        "onUpdate:input": _cache[0] || (_cache[0] = ($event: any) => (_ctx.email = $event)),
        class: "btn",
        text: "enviar"
      })
    ])
  ]))
}